<form id="form-subscrition" [formGroup]="form" autocomplete="off" (ngSubmit)="onSubmit()">
  <div class="fields-container" *ngIf="!processingForm && !sentIt">
    <p *ngIf="formMessage" class="form-header" [attr.data-translate]="formMessage">{{ formMessage }}</p>
    <div class="form-group">
      <input
        formInput
        formControlName="firstname"
        type="text"
        class="form-control"
        id="firstname"
        autocomplete="chrome-off"
        required
        placeholder="name"
        i18n-placeholder="@@public.commons.subscribe.form.firstname"
        [attr.data-translate-placeholder]="'public.commons.subscribe.form.firstname'"
      /><span></span>
    </div>
    <div class="form-group">
      <input
        formInput
        formControlName="lastname"
        type="text"
        class="form-control"
        id="lastname"
        autocomplete="chrome-off"
        required
        placeholder="lastname"
        i18n-placeholder="@@public.commons.subscribe.form.lastname"
        [attr.data-translate-placeholder]="'public.commons.subscribe.form.lastname'"
      /><span></span>
    </div>
    <div class="form-group">
      <input
        formInput
        formControlName="email"
        type="email"
        class="form-control"
        id="email"
        autocomplete="off"
        required
        placeholder="email"
        i18n-placeholder="@@public.commons.subscribe.form.email"
        [attr.data.translate-placeholder]="'public.commons.subscribe.form.email'"
      /><span></span>
    </div>
    <div class="p-col-12" *ngIf="touched && !processingForm">
      <small *ngIf="form.get('email').errors" class="text-danger" i18n="@@public.error.provideEmail"
        >Please provide a valid email address</small
      >
    </div>
    <button type="submit" class="btn-submit button" i18n="@@competition.form.submit">Submit</button>
  </div>
  <!-- Loading Template-->

  <ush-loading-indicator
    *ngIf="processingForm"
    [style.height]="'100%'"
    [style.width]="'100%'"
    height="100%"
    fontSize="30px"
  ></ush-loading-indicator>
  <!-- Thank you message if success -->
  <div *ngIf="sentIt" class="sentIt form-header" i18n="@@public.commons.thanksSubscription">
    Thank you for subscribing, a confirmation email has been sent to you.
  </div>
</form>
